import React, { createContext, useContext, useState, useEffect, useMemo } from "react";
import services from "../services/indexService";
import useToast from "../hooks/useToast";
import AlertPopup from "../components/index/AlertPopup";
import { policyNumberCheck } from "../../utils/regexCheck";
import { appInsights } from "../../telemetry/telemetryService";


export const taskPaneInitailValue = {
        // Index
        docDescription: "",
        documentClass: "",
        documentType: "",
        receivedDate: "",
        chkQuoteSentToProducer: false,
        useFileName: false,
        docNotes:  "",
        // task
        taskChecked: false,
        taskSubject: "",
        sameAsDocDesc: false,
        taskQueue: "",
        taskType: "",
        taskNote: "",
        taskDueDate: "",
        taskStartDate: "",
        taskPriority: "",
        checklistItem: ""
      }
const TaskPaneContext = createContext({
  selectedGridItem: [],
  selectedItemDetailFromGrid: null,
  setSelectedGridItem: (_selectedItems) => {},
  queues: [],
  setQueues: (_queues = []) => {},
  userGroups: [],
  setUserGroups: (_values = []) => {},
  user: [],
  setUsers: (_values = []) => {},
  taskTypes: [],
  setTaskTypes: (_values = []) => {},
  taskPaneState: {
    searchText: null,
    compId: null,
    comLocId: null,
    criteria: null,
    insuredId: null,
    userId: null,
    userGroupId: null,
    taskTypeId: null,    
   },
   accessToken: null,
});

export const TaskPaneProvider = ({ children }) => {
    const [loading, setLoading] = useState(false);
  const [taskPaneState, setTaskPaneState] = useState({
    searchText: null,
    compId: null,
    comLocId: null,
    criteria: null,
    insuredId: null,
    userId: null,
    userGroupId: null,
  });
  //
  const [username, setUsername] = useState(null);
  const [accessToken, setAccessToken] = useState(null);
  const isDialog = new URLSearchParams(window.location.search).get("dialog") === "true";
  //
  const { notify, Toaster } = useToast();
  const [profileDetails, setProfileDetails] = useState([]);
  const [locationData, setLocationData] = useState([]);
  const [policiesDetailsForInsured, setPoliciesDetailsForInsured] = useState([]);
  const [selectedGridItem, setSelectedGridItem] = useState([]);
  const [priorityList, setPriorityList] = useState([]);
  const [documentType, setDocumentType] = useState([]);
  const [documentClass, setDocumentClass] = useState([]);
  const [userGroups, setUserGroups] = useState([]);
  const [queues, setQueues] = useState([]);
  const [user, setUsers] = useState([]);
  const [taskTypes, setTaskTypes] = useState([]);
  const [checkList, setCheckList] = useState([]);
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [title, setTitle] = useState("");
  const getPoliciesDetailsForInsuredData = 
    async (InsuredID, SubmissionStatusID, LoggedInCompLocID, ViewAllCompLocs) => {
      setPoliciesDetailsForInsured([]);
      setSelectedGridItem([]);
      setTaskPaneState((prev) => ({ ...prev }));
      try {
        const result = await services.getPoliciesDetailsForInsured(
          InsuredID,
          SubmissionStatusID,
          LoggedInCompLocID,
          ViewAllCompLocs,
          taskPaneState?.userId
        );
        if(!!result && result?.length) {
          setSelectedGridItem(result?.length ? new Set([ taskPaneState?.isEmailSub? taskPaneState?.policyId : result[0]?.policyID]) : []);
          setPoliciesDetailsForInsured(result);
        setTaskPaneState((prev) => ({ ...prev, isEmailSub: false }));
        return result;
      } else {
          setTitle("Search result");
          setText("No policy details found");
          // setOpen(true);
          }
      } catch (e) {
        if(e?.response?.status === 403) {
          setTitle(e?.response?.data?.error === "AccessDenied"? "Access Denied" : "Search Failed")
          setText(e?.response?.data?.message)
          // setOpen(true);
          }
        setTaskPaneState((prev) => ({ ...prev}));
        setPoliciesDetailsForInsured([]);
        setSelectedGridItem([]);
      }
    }

  useEffect(() => {
    if(taskPaneState.comLocId)
      getPriorityList();
  }, [taskPaneState.comLocId]);
  
  const getPriorityList = async () => {
    try {
      const result = await services.getPriorityList();
      setPriorityList(result);
    } catch (e) {
      setPriorityList([]);
      console.log(e);
    }
  };

  const filterTypeByCriteriaType = useMemo(
    () =>
      taskPaneState?.criteria === "Insured" || taskPaneState?.criteria === "Policy #" || taskPaneState?.criteria === "Submission #"
        ? "Type Insured/Policy"
        : taskPaneState?.criteria === "Producer #" || taskPaneState?.criteria === "Producer Name"
          ? "Type Producer"
          : "Type claim",
    [taskPaneState?.criteria]
  );

  const selectedItemDetailFromGrid = useMemo(() => {
    if (filterTypeByCriteriaType === "Type Insured/Policy" && policiesDetailsForInsured) {
      const selectedPolicy = policiesDetailsForInsured?.find((item) => item.policyID === [...selectedGridItem][0]);
      setTaskPaneState((prev) => ({ 
        ...prev, 
        // receivedDate: formatToYyyyMmDd(selectedPolicy?.receiveDate),
        chkQuoteSentToProducer: !!selectedPolicy?.chkQuoteSentToProducer ?? false,
        unlockchkQuoteSentToProducer: !!selectedPolicy?.unlockchkQuoteSentToProducer ?? false,
        policychkQuoteSentToProducer: !!selectedPolicy?.policychkQuoteSentToProducer ?? false,
        //docDescription: selectedPolicy?.docDescription?.length ? selectedPolicy.docDescription.substring(0, 60) : "", documentType: selectedPolicy?.documentType ?? "",
        //documentType: selectedPolicy?.documentType ?? "",
        // useFileName: !!selectedPolicy?.useFileName ?? false,
        //documentClass: selectedPolicy?.documentClass ?? "",
        // emailSubject: selectedPolicy?.emailSubject ?? "",
        docNotes: selectedPolicy?.docNotes?.length ? selectedPolicy?.docNotes.substring(0, 255) : "", 

        useChecklistItem:  false,
        docDescription: prev?.useChecklistItem? "" : prev?.docDescription,
        sameAsDocDesc: (!!prev?.useChecklistItem && !!prev?.sameAsDocDesc)? false : !!prev?.sameAsDocDesc,
        taskSubject: (!!prev?.useChecklistItem && !!prev?.sameAsDocDesc)? "" : prev?.taskSubject,
       }));
      return selectedPolicy;
    } else {
      const selectedProducer = policiesDetailsForInsured?.find((item) => item.producerId === [...selectedGridItem][0]);
      return {
        ProducerID: selectedProducer?.producerId,
        policyNumber: "",
        lob: "",
      };
    }
  }, [selectedGridItem, policiesDetailsForInsured, filterTypeByCriteriaType]);

  useEffect(() => {
 if(selectedItemDetailFromGrid?.policyID && taskPaneState.comLocId && taskPaneState.userId && taskPaneState.documentType) {
  getIndexFormDetails(taskPaneState?.documentType, taskPaneState.comLocId, !!sessionStorage.getItem("actionType"), selectedItemDetailFromGrid?.policyID, null, taskPaneState.userId, taskPaneState.emailSubject)
 } else {
  if(!selectedItemDetailFromGrid?.ProducerID && !selectedItemDetailFromGrid?.policyID) {
    setTaskPaneState((prev) => ({ ...prev, ...taskPaneInitailValue, userGroupId: prev?.profileUserGroupId, userGroup: prev?.userId }));
  }
 }
  }, [taskPaneState?.documentType, selectedItemDetailFromGrid?.policyID]);

  const getIndexFormDetails =async (imgKeywordId,
    CompLocID,
    EmailIndex,
    policyID,
    policyDetailId,
    userId,
    txtSubject) => {
    try {
      //notify("progress");
      const result = await services.GetIdsByImageKeywordSelect(
       imgKeywordId,
        CompLocID,
        true,
        policyID,
        policyDetailId,
        userId,
        txtSubject
      );
      setTaskPaneState((prev) => ({
        ...prev,
        docDescription: result?.docDescription?.length? result?.docDescription.substring(0, 60): "",
        documentClass: result?.documentClassID ?? "",
        // documentType: result?.imgKeywordID ?? "",
        // receivedDate: formatToYyyyMmDd(result?.receiveDate),
        // chkQuoteSentToProducer: result?.chkQuoteSentToProducer ?? false,
        useFileName: result?.docDescription?.length? false : prev?.useFileName,
        useChecklistItem: result?.docDescription?.length? false : prev?.useChecklistItem,
        // emailSubject: result?.subject ? result?.subject: taskPaneState?.emailSubject,
        // docNotes: result?.docNotes ?? "",
        // task
        taskChecked: result?.chkTask,
        taskSubject: result?.txtSubject?.length? result?.txtSubject.substring(0, 60): "",
        sameAsDocDesc: (result?.docDescription?.length || result?.txtSubject?.length)? false : prev?.sameAsDocDesc,
        userGroupId: result?.userGroupID? result?.userGroupID : taskPaneState?.profileUserGroupId,
        userGroup: result?.assignedId ? result?.assignedId : taskPaneState?.userId,
        taskQueue: result?.imgCommonQueueID,
        taskType: result?.taskTypeID,
        // taskNote: result?.docNotes?? "",
        taskDueDate: result?.dueDateOnly,
        taskStartDate: result?.startDateOnly,
        taskPriority: result?.priorityID
      }));
    } catch (e) {
      //notify("error", "Failed to fetch GetIdsByImageKeywordSelect data");
      console.log(e);
    }
  }
  const getDocumentType = async (comLocId) => {
    try {
      const result = await services.getDocumentType(comLocId);
      setDocumentType(result);
    } catch (e) {
      setDocumentType([]);
      console.log(e);
    }
  };

    const getDocumentClass = async (comLocId, criteria) => {
    try {
      const result = await services.getDocumentClass(criteria, comLocId, false);
      setDocumentClass(result);
    } catch (e) {
      setDocumentClass([]);
      console.log(e);
    }
  };

  const getUserGroupsForPerson = async (userId) => {
    try {
      const result = await services.getUserGroupsForPerson(userId);
      setUserGroups(result);
      setTaskPaneState((prev) => ({ ...prev}));
    } catch (e) {
      console.log(e);
      setUserGroups([]);
    }
  };
  const getQueuesForUserGroup = async (userGroupId) => {
    try {
      const result = await services.getQueuesForUserGroup(userGroupId);
      setQueues(result);
      setTaskPaneState((prev) => ({ ...prev}));
    } catch (e) {
      console.log(e);
      setQueues([]);
    }
  };

  const getPersonUserGroupXRef = async (userGroupId, activeOnly, activeAndExpiredWithOpenTask) => {
    try {
      const result = await services.getPersonUserGroupXRef(
        userGroupId,
        activeOnly,
        activeAndExpiredWithOpenTask
      );
      setUsers(result);
      setTaskPaneState((prev) => ({ ...prev}));
    } catch (e) {
      setUsers([]);
      console.log(e);
    }
  };
  const getCheckList = async (PolicyId, Completed, CompLocID, IncludeNone) => {
    try {
      setTaskPaneState((prev) => ({ ...prev, checklistItem: "" }));
      const result = await services.getPolicyChecklistForPolicy(
        PolicyId,
        Completed,
        CompLocID,
        IncludeNone
      );
      setCheckList(result);
    } catch (e) {
      setCheckList([]);
      setTaskPaneState((prev) => ({ ...prev, checklistItem: "" }));
    }
  };
  const getTaskTypes = async (userGroupId) => {
    try {
      const result = await services.getTaskTypes(0, userGroupId);
      setTaskTypes(result);
    } catch (e) {
      setTaskTypes([]);
    }
  };
  useEffect(() => {
    if (taskPaneState.comLocId) {
      getDocumentType(taskPaneState.comLocId);
    }
  }, [taskPaneState.comLocId]);

    useEffect(() => {
    if (taskPaneState.comLocId && taskPaneState.criteria) {
      getDocumentClass(taskPaneState.comLocId, taskPaneState.criteria);
    }
  }, [taskPaneState.comLocId, taskPaneState.criteria]);
  useEffect(() => {
    if (taskPaneState?.insuredId && taskPaneState.comLocId && (taskPaneState?.criteria  === "Policy #" || taskPaneState?.criteria  === "Insured" || taskPaneState?.criteria  === "Submission #")) {
      if(!taskPaneState?.isSearch) getPoliciesDetailsForInsuredData(taskPaneState?.insuredId, -1, taskPaneState.comLocId, false);
      else setTaskPaneState((prev) => ({ ...prev, isSearch: false  }));
    }
  }, [taskPaneState?.insuredId]);

  //   useEffect(() => {
  //   if (taskPaneState?.insuredId && taskPaneState.comLocId && filterTypeByCriteriaType === "Type Insured/Policy") {
  //     getPoliciesDetailsForInsuredData(taskPaneState?.insuredId, -1, taskPaneState.comLocId, false);
  //   }
  // }, [taskPaneState?.criteria]);

  //   useEffect(() => {
  //   if (!!taskPaneState?.useFileName) {
  //     setTaskPaneState((prev) => ({ ...prev, docDescription: "", sameAsDocDesc: false  }));
  //   }
  // }, [taskPaneState?.useFileName]);

  useEffect(() => {
    if (taskPaneState.userId && taskPaneState?.compLocId) {
      getUserGroupsForPerson(taskPaneState.userId);
    }
  }, [taskPaneState.userId, taskPaneState?.compLocId]);
  useEffect(() => {
    if (taskPaneState.userGroupId) {
      getQueuesForUserGroup(taskPaneState.userGroupId);
      getPersonUserGroupXRef(taskPaneState.userGroupId, true, false);
      getTaskTypes(taskPaneState.userGroupId);
    } else {
      setQueues([]);
      setUsers([]);
      setTaskTypes([]);
    }
  }, [taskPaneState.userGroupId]);

  useEffect(() => {
    if(taskPaneState?.comLocId && taskPaneState?.userId)
      getCheckList(selectedItemDetailFromGrid?.policyID, false, taskPaneState?.comLocId, true)
  }, [taskPaneState?.comLocId, taskPaneState?.userId, selectedItemDetailFromGrid?.policyID]);

    useEffect(() => { }, [selectedItemDetailFromGrid, taskPaneState.comLocId]);

       useEffect(() => {
        if(taskPaneState?.userId) {
            Office.onReady().then(() => {
                Office.context.ui.messageParent("ready");

                // Office.context.ui.addHandlerAsync(
                //     Office.EventType.DialogParentMessageReceived,
                //     (arg) => {
                //         const message = JSON.parse(arg.message);
                //         localStorage.setItem("access-token", message?.token);
                //         setAccessToken(message?.token);
                //     }
                // );
            });
          Office.onReady((info) => {
      if (info.host === Office.HostType.Outlook) {
        const item = sessionStorage.getItem('mailsubject');
        setSubject(item?? "");
      }
    });
  }
    }, [taskPaneState?.userId]);

     function containsLetterAndNumber(str) {
    const hasLetter = /[a-zA-Z]/.test(str);
    const hasNumber = /\d/.test(str);
    const hasOnlyAlphanumeric = /^[a-zA-Z0-9]+$/.test(str);
    return (hasLetter && hasNumber && hasOnlyAlphanumeric) || (hasNumber && hasOnlyAlphanumeric);
    }

  function isValidPolicyNumber(value) {
    if (!value) return false;
    value = value.trim();
    // Allowed characters and structure (segments separated by . / -), optional trailing separator
    console.log("value", value);
    const allowedShape = /^[A-Za-z0-9]+(?:[./-][A-Za-z0-9]+)*[./-]?$/i.test(value);
    console.log("allowedShape", allowedShape);
    
    // Require at least one digit OR one of the separators
    const hasDigitOrSeparator = /[0-9./-]/.test(value);
    console.log("hasDigitOrSeparator", hasDigitOrSeparator);

    return allowedShape && hasDigitOrSeparator;
  }
const re = /(?:Policy|Pol)(?:\s*(?:Number|Num))?\s*(?:[:#]\s*)*(?:\bRenewal\b\s+of\s+)?([^\s,;]+)/i;

function extractPolicyNumber(text) {
  const m = text.match(re);
  return m ? m[1].trim() : null;
}

  const setSubject = (subject) => {
    const matchSubmissionNumber2 = subject.match(/ref\s*[^A-Za-z0-9]*\s*([A-Za-z0-9]+)/i);
    const matchSubmissionNumber = matchSubmissionNumber2 || null;
    const matchPolicyNumber1 = policyNumberCheck(subject);
    console.log('matchPolicyNumber1', matchPolicyNumber1);
    const matchPolicyNumber = matchPolicyNumber1 || null;
    let submissionNumber = null;
    let policyNumber = null;
    if (matchPolicyNumber) {
      policyNumber = matchPolicyNumber? matchPolicyNumber: null;
    }
    if (matchSubmissionNumber) {
      submissionNumber = containsLetterAndNumber(matchSubmissionNumber[1])?matchSubmissionNumber[1] : matchSubmissionNumber[1];
    }
    if (policyNumber || submissionNumber) {
      getLocationSpecificInfoEmail(policyNumber, submissionNumber)
    } else getLocationData();
    setTaskPaneState((prev) => ({ ...prev, emailSubject: subject }));
  }

  const getLocationSpecificInfoEmail = async (policyNumber, submissionNumber) => {
    try {
      const result = await services.getLocationSpecificInfo(
        null,
        null,
        taskPaneState?.userId,
        -1,
        null,
        false,
        false,
        true,
        policyNumber,
        submissionNumber,
      );
      // notify("success", "LocationSpecificInfo data fetch successful!");
      const locationDetailByEmailResults = result?.locationDetailByEmailResults;
      if(locationDetailByEmailResults?.compLocId && 
        locationDetailByEmailResults?.companyID && 
        locationDetailByEmailResults?.insuredID &&
        locationDetailByEmailResults?.policyId) {
      setTaskPaneState((prev) => ({
        ...prev,
        ...result,
        useFileName: result?.chkTask ?? false,
        // taskPriority: "01",
        comLocId: locationDetailByEmailResults?.compLocId?.toString() || null,
        compLocId: locationDetailByEmailResults?.compLocId?.toString() || null,
        compId: locationDetailByEmailResults?.companyID || null,
        insuredId: locationDetailByEmailResults?.insuredID || null,
        criteria: locationDetailByEmailResults?.criteria || result?.criteriaItems[0]?.criteriaName,
        isEmailSub: true,
        policyId: locationDetailByEmailResults?.policyId
      }));
      getLocationData(false);
    } else {
      getLocationData();
    }
      // setDocumentType(result?.documentTypesResults || []);
    } catch (e) {
      getLocationData();
      if(e?.status === 403) {
      setTitle("Search result");
      let errorText = "Permission does not exist for Company Location tied to selected Policy.";
      if(policyNumber && submissionNumber) {
        errorText = `Permission does not exist for Company Location tied to selected Policy # ${policyNumber} and Submission # ${submissionNumber}`;
      } else if(policyNumber) {
        errorText = `Permission does not exist for Company Location tied to selected Policy # ${policyNumber}`;
      } else if(submissionNumber) {
        errorText = `Permission does not exist for Company Location tied to selected Submission # ${submissionNumber}`;
      }
      setText(errorText);
      setOpen(true);
    } else if(e?.status === 500) {
      notify("error", e?.response?.data?.message || "Failed to fetch LocationSpecificInfo data!");
    } else {
      notify("error", "Failed to fetch LocationSpecificInfo data");
    }
      console.log(e);
      appInsights.trackDependencyData({
        target: process.env.BASE_URL,
        name: "Outlook_LocationSpecificInfo_Payload",
        dependencyTypeName: "HTTPS",
        success: false,
        responseCode: e?.status || 500,
        properties: {
          bodyData: {
            policyNumber,
            submissionNumber,
            userId: taskPaneState?.userId
          },
          error: e,
          userId: taskPaneState.userId
        }
      });
    }
  };

    const getLocationData = async (isCheck=true) => {
      try {
          notify("progress");
          const result = await services.bindLocation(username);
          notify("success", "Location data fetch successful!");
          setLocationData(result);
          if(result?.length ===1 && isCheck) {
             setPoliciesDetailsForInsured([]);
            setSelectedGridItem([]);
            setCheckList([]);
            const value = result[0]?.compLocID;
            const compId = profileDetails.filter((pd) => pd.compLocID == value)[0]?.companyID;
            setTaskPaneState((prev) => ({ ...prev, comLocId: value, compLocId: value, compId, checklistItem: "" }));
            if(value && compId)
              await getLocationSpecificInfo(value, compId);
            }
      } catch (e) {
          notify("error", "Failed to fetch location data");
          console.log(e);
      }
    };
  
    const getLocationSpecificInfo = async (comLocId, compId, criteria="") => {
      try {
        const userId = taskPaneState?.userId;
        // notify("progress");
        setTaskPaneState((prev) => ({
          ...prev,
          criteria: "",
          insuredId: ""
        }));
        const result = await services.getLocationSpecificInfo(
          comLocId,
          compId,
          userId,
          -1,
          comLocId,
          false,
          false
        );
        notify("success", "LocationSpecificInfo data fetch successful!");
        setTaskPaneState((prev) => ({
          ...prev,
          ...result,
          criteria: criteria? criteria: result?.criteriaItems[0]?.criteriaName ?? "",
          insuredId: result?.insuredForRecentPoliciesResults[0]?.insuredID ?? "",
          useFileName: result?.chkTask ?? false,
        }));
        // setDocumentType(result?.documentTypesResults || []);
      } catch (e) {
        notify("error", "Failed to fetch LocationSpecificInfo data");
        console.log(e);
        appInsights.trackDependencyData({
          target: process.env.BASE_URL,
          name: "Outlook_LocationSpecificInfo_Payload",
          dependencyTypeName: "HTTPS",
          success: false,
          responseCode: e?.status || 500,
          properties: {
            bodyData: {
              comLocId,
              compId,
              userId: taskPaneState?.userId,
            },
            error: e,
            userId: taskPaneState.userId
          }
        });
      }
    };
  
  return (
    <TaskPaneContext.Provider
      value={{
        profileDetails,
        setProfileDetails,
        locationData,
        setLocationData,
        taskPaneState,
        setTaskPaneState,
        policiesDetailsForInsured,
        setPoliciesDetailsForInsured,
        getPoliciesDetailsForInsuredData,
        filterTypeByCriteriaType,
        selectedGridItem,
        setSelectedGridItem,
        selectedItemDetailFromGrid,
        documentType,
        setDocumentType,
        setDocumentClass,
        documentClass,
        userGroups,
        setUserGroups,
        queues,
        setQueues,
        user,
        setUsers,
        taskTypes,
        setTaskTypes,
        checkList,
        accessToken,
        priorityList,
        setCheckList,
        getLocationSpecificInfo,
        setUsername,
        username,
        loading, 
        setLoading
      }}
    >
      {Toaster}
      {open && 
       <AlertPopup
       title= {title} 
       text={text} 
       open={open} 
       handleClose = {()=> {
        setOpen(false);
        setTitle("");
        setText("");
        }}/>}
      {children}
    </TaskPaneContext.Provider>
  );
};

export const useTaskPane = () => {
  const taskPaneContext = useContext(TaskPaneContext);

  if (!taskPaneContext) {
    throw new Error("hook canot be used outside of the TaskPaneProvider");
  }
  return taskPaneContext;
};
